import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOfferTypeById = function () {
    return useApiCall(function (signal, id) { return api.configuration.apiConfigurationOfferTypeIdGet(id, { signal: signal }); }, null, true, []);
};
